// @flow

import * as React from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import userApi from "../api/user";
import useAsyncState from "../hooks/useAsyncState";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import Button from "../components/atoms/Button";
import ServerErrorMessage from "../components/atoms/ServerErrorMessage";
import CustomMeta from "../components/atoms/CustomMeta";

const ForgotPassword = (): React.Node => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [state, localActions] = useAsyncState();

    const handleFormSubmit = async (formData: any): any => {
        if (!executeRecaptcha) {
            localActions.fail("reCAPTCHA is still loading. Please try again.");
            return;
        }

        const googleRecaptchaResponse = await executeRecaptcha(
            "forgot_password"
        );

        localActions.request();

        userApi
            .userForgotPassword(formData.email, googleRecaptchaResponse)
            .then(res => {
                localActions.success();
                // props.history.push("/");
            })
            .catch((error: any) => {
                console.error(error);

                localActions.fail(
                    error.message || "Unable to send forgot password email."
                );
            });
    };

    return (
        <React.Fragment>
            <CustomMeta title="Forgot Password" />

            <HeroProfilePage heading="Forgot Password" />

            <div className="login-profile-body container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <div className="row">
                            <div className="col-xs-12 col-md-10 col-lg-6">
                                <p className="page-intro">
                                    {state.success
                                        ? "Check your inbox! We've sent you an email with instructions on how to reset your password."
                                        : "Forgotten your password? Submit your email to reset your password."}
                                </p>

                                <ServerErrorMessage>
                                    {state.error}
                                </ServerErrorMessage>

                                <ReactForm
                                    className={state.error ? "is-invalid" : ""}
                                    onSuccess={handleFormSubmit}
                                >
                                    <ReactFormField
                                        type="email"
                                        label="Email"
                                        name="email"
                                        required={true}
                                        validators={["email"]}
                                        errorMessages={{
                                            required:
                                                "Please enter your email.",
                                        }}
                                    />

                                    <Button
                                        type="submit"
                                        styles={["green"]}
                                        aria-label="Login"
                                        loading={state.loading}
                                        success={!!state.success}
                                    >
                                        Send email
                                    </Button>
                                </ReactForm>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ForgotPassword;
